export default "__VITE_ASSET__CINICmGe__"